export default "__VITE_ASSET__ec02e811__"